import apiClient from './client';
import {
    DomainSummary,
    DomainWithBlocks,
    GenerateBlocksRequest
} from '@/types/project.ts';
import { getSelectedNetwork } from '@/lib/gamNetwork';

// ========== DOMAINS / AD UNITS API ==========

// As duas listagens seguem a conta GAM do seletor, como getDomains.
const paramsDaConta = () => {
    const network = getSelectedNetwork();
    return network ? { network } : undefined;
};

// Listar domínios com blocks
export const getDomainsWithBlocks = async (): Promise<DomainWithBlocks[]> => {
    const response = await apiClient.get<DomainWithBlocks[]>('/ad_unit/domains', { params: paramsDaConta() });
    return response.data;
};

// Resumo de domínios / ad units
export const getSummary = async (): Promise<DomainSummary[]> => {
    const response = await apiClient.get<DomainSummary[]>('/ad_unit/summary', { params: paramsDaConta() });
    return response.data;
};

// Gerar blocks
export const generateBlocks = async (
    data: GenerateBlocksRequest
): Promise<any> => {
    const response = await apiClient.post('/ad_unit/generate', data);
    return response.data;
};

// ========== STATUS UPDATES API ==========

// Atualizar status de um block
export const updateBlockStatus = async (
    blockId: number,
    status: string
): Promise<any> => {
    const response = await apiClient.patch(
        `/ad_unit/blocks/${blockId}/status`,
        { status }
    );
    return response.data;
};

// Atualizar status de um root
export const updateRootStatus = async (
    rootId: number,
    status: string,
    updateRoot: boolean
): Promise<any> => {
    const response = await apiClient.patch(
        `/ad_unit/roots/${rootId}/status`,
        {
            status,
            update_root: updateRoot
        }
    );
    return response.data;
};
